import { Wrapper, ExploreButton } from './Buttons.styles';

export default function CarvanaButtons() {
  return (
    <Wrapper>
      <a
        href="/"
        data-analytics-id="Explore Carvana button"
        data-testid="explore-carvana"
      >
        <ExploreButton>Explore Carvana</ExploreButton>
      </a>
    </Wrapper>
  );
}
